module.exports = __webpack_public_path__ + "static/img/RP-U48V5_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RP-U48V5_1.png
// module id = Bo31
// module chunks = 0